import { useState } from "react";
import { Check } from "lucide-react";
import { Frame, Node, Flow, Detail } from "@/components/diagrams/kit";

const PHASES = [
  { name: "Sandbox pilot", scope: "One line", items: ["Safe historical or synthetic data", "Read-only tools", "Clear evaluation set", "Named business owner"] },
  { name: "Multi-line scale", scope: "Several lines", items: ["Standardize data contracts", "Onboard more lines", "Certify users", "Monitor quality and adoption", "Add controlled live data"] },
  { name: "Enterprise rollout", scope: "All sites", items: ["Integrate with operating routines", "Governance and support", "Model evaluation", "Cost controls", "Continuous value tracking"] },
];

export default function RoadmapStepper() {
  const [sel, setSel] = useState(0);
  const [done, setDone] = useState({});
  const ph = PHASES[sel];
  const key = (i) => `${sel}-${i}`;
  const ready = ph.items.every((_, i) => done[key(i)]);
  return (
    <Frame title="Phased rollout" hint="Tick the gate criteria" testId="diagram-roadmap">
      <div className="flex flex-col sm:flex-row">
        {PHASES.map((p, i) => (
          <div key={p.name} className="flex flex-col sm:flex-1 sm:flex-row">
            <Node testId={`roadmap-phase-${i}`} tone={i === sel ? "primary" : i < sel ? "accent" : "neutral"} active={i === sel} onClick={() => setSel(i)}>
              <div className="font-mono text-[10px] uppercase text-muted-foreground">Phase {i + 1} · {p.scope}</div>
              <div className="font-heading font-bold">{p.name}</div>
            </Node>
            {i < PHASES.length - 1 && <Flow on={i < sel} />}
          </div>
        ))}
      </div>
      <div className="mt-4 grid gap-2 sm:grid-cols-2">
        {ph.items.map((it, i) => (
          <button key={it} type="button" data-testid={`roadmap-item-${i}`} onClick={() => setDone({ ...done, [key(i)]: !done[key(i)] })} className={`flex items-center gap-3 border p-3 text-left text-sm ${done[key(i)] ? "border-brand-accent bg-brand-accent/10" : "border-border bg-card"}`}>
            <span className={`flex h-5 w-5 items-center justify-center border ${done[key(i)] ? "border-brand-accent bg-brand-accent text-brand-accent-fg" : "border-border"}`}>{done[key(i)] && <Check className="h-3 w-3" />}</span>{it}
          </button>
        ))}
      </div>
      <Detail testId="roadmap-gate"><span key={sel + String(ready)}>{ready ? (sel < 2 ? <>Gate met. <button type="button" className="font-semibold text-brand-primary underline" onClick={() => setSel(sel + 1)}>Advance to {PHASES[sel + 1].name} →</button></> : "Enterprise gate met — keep tracking value continuously.") : `Gate not met: ${ph.items.filter((_, i) => !done[key(i)]).length} criteria open before scaling beyond “${ph.name}”.`}</span></Detail>
    </Frame>
  );
}
